import React from 'react';
import { useTranslation } from 'react-i18next';
import { services } from './ServicesDataPrivateCloud';
import { Timeline } from '../../ui/timeline';

const TimelinePrivateCloud: React.FC = () => {
  const { t } = useTranslation();
  
  const timelineItems = services.map(service => ({
    date: "",
    title: service.titleKey ? t(service.titleKey, service.title) : service.title,
    description: service.descriptionKey ? t(service.descriptionKey, service.description) : service.description,
    icon: service.icon,
    features: service.features
      .filter(f => f.text !== '')
      .map((f, index) => ({
        text: t(`dataCyber.timeline.services.${service.id}.features.${index + 1}`, f.text)
      }))
  }));

  return (
    <div className="tw-container tw-mx-auto pb-16 bg-transparent tw-px-4 sm:px-4 md:px-4 lg:px-0 xl:px-0 2xl:px-0">
      <div className="centered-title-dark-bg-approche">
        <h2>{t('dataCyber.timeline.title', 'Notre approche')}</h2>
      </div>
      <Timeline items={timelineItems} />
    </div>
  );
};

export default TimelinePrivateCloud;